/**
 * Hyperlocal query fields (`h1_title`, `h2_subtitle`, `page_copy`) are stored
 * as plain text. Richtext slots need HTML, so wrap paragraphs and escape
 * markup. Strings that are already HTML pass through unchanged.
 */
export function hyperlocalToRichText(value: string | null | undefined, fallback: string): string {
  const text = value?.trim();
  if (!text) return fallback;
  if (/<\/?[a-z][\s\S]*>/i.test(text)) return text;

  return text
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br>')}</p>`)
    .join('');
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
